/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import InvoiceTabs from './invoiceTabs';
import {
  getPrintCover,
  getPrintAll,
  updateDuplicateInvoice,
  setErrorMessagesData,
} from '../store/actions';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import { convertPDFFromAPI } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import _ from 'lodash';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import * as CONSTANTS from '../../../../SharedModules/AppConstants';

function RequestInvoiceReportDetails() {
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = useState(false);
  const [successMessages, setSuccessMessages] = useState([]);
  const [pdfUrl, setPdfURL] = React.useState(null);
  const [loading, setLoading] = useState(false);
  const [printPdfRedirect, setPrintPdfRedirect] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);

  const rebateProgramCode = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer?.rebateProgramCode?.data
  );
  const invoiceDetailsByInvoiceNum = useSelector(
    (state) =>
      state.sharedState?.InvoiceReportReducer?.invoiceDetailsByInvoiceNum?.data
  );
  const invoiceQuarter = useSelector(
    (state) => state.sharedState?.DisplayInvoiceReducer?.invoiceQuarter
  );
  const pdfPreview = useSelector(
    (state) => state.sharedState?.InvoiceReportReducer?.pdfPreview
  );
  const duplicateInvoice = useSelector(
    (state) => state.sharedState?.InvoiceReportReducer?.duplicateInvoice
  );
  const searchInvoiceRequest = useSelector(
    (state) =>
      state.sharedState?.InvoiceReportReducer?.searchInvoiceReportRequest
  );
  const errorMess = useSelector(
    (state) => state.sharedState?.InvoiceReportReducer?.errorMessages
  );
  const invoiceNumber = useSelector(
    (state) =>
      state.sharedState?.InvoiceReportReducer?.invoiceDetailsByInvoiceNum?.data
        ?.invoiceNum || null
  );

  const UserDefaultValues = useSelector(
    (state) => state.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  localStorage.setItem('UserDefaultValues', JSON.stringify(UserDefaultValues));

  const handleErrorMessages = (messages) => {
    setErrorMessages(messages);
    dispatch(setErrorMessagesData(messages));
  };

  const onClickPrint = async () => {
    try {
      const res = await dispatch(
        getPrintAll({
          invoiceNum: [invoiceNumber],
          rebateProgramCd: searchInvoiceRequest?.rebateProgramCode,
          userId: UserDefaultValues?.userId,
          duplicate: duplicateInvoice,
        })
      );
      if (res == null) {
        handleErrorMessages([CONSTANTS.NO_DATA_PRINT]);
        setPrintPdfRedirect(false);
      } else {
        setPrintPdfRedirect(true);
        //setTimeout(() => {
        // setPrintPdfRedirect(false);
        //}, 2000);
      }
    } catch (error) {
      setLoading(false);
      handleErrorMessages([CONSTANTS.NO_DATA_PRINT]);
    }
  };

  useEffect(() => {
    if (printPdfRedirect) {
      setLoading(true);
      setPrintPdfRedirect(false);
      if (pdfPreview && pdfPreview !== '') {
        const purl = convertPDFFromAPI(pdfPreview);
        setPdfURL(purl);
      }
      setLoading(false);
    }
    return () => {
      setPrintPdfRedirect(false);
    };
  }, [printPdfRedirect]);

  useEffect(() => {
    const detailsErrors = (errorMess || []).filter(
      (x) =>
        x &&
        !String(x).includes(CONSTANTS.INVOICE_NOT_FOUND) &&
        !String(x).toLowerCase().includes('no record')
    );
    setErrorMessages(detailsErrors);
    if (detailsErrors.length !== (errorMess || []).length) {
      dispatch(setErrorMessagesData(detailsErrors));
    }
  }, [errorMess]);

  // function duplicateInvoiceUpdate(e) {
  //   handleErrorMessages([]);
  //   dispatch(
  //     updateDuplicateInvoice({
  //       duplicateInvoice: e.target.checked,
  //     })
  //   );
  //   dispatch(
  //     getPrintCover({
  //       invoiceNum: [invoiceNumber],
  //       rebateProgramCd: searchInvoiceRequest?.rebateProgramCode,
  //       userId: UserDefaultValues?.userId,
  //       duplicate: e.target.checked,
  //     })
  //   );
  // }

  const duplicateInvoiceUpdate = (e) => {
    dispatch(updateDuplicateInvoice({ duplicateInvoice: e.target.checked }));
  };

  return (
    <>
      <div className='tBillPanel custom-check'>
        {loading && <Spinner load={loading} />}
        <div className='panel tBillPanel-space pb-0'>
          <DisplaySuccessMessages successMessages={successMessages} />
          <DisplayErrorMessages errorMessages={errorMessages} />
          {!fullScreenView && (
            <>
              <CustomSeparator
                parent1='Display'
                parent2='Invoice Report Details'
              />
              <fieldset className='custom-fieldset'>
                <form autoComplete='off'>
                  <div className='form-wrapper row'>
                    <div className='mui-custom-form input-md col-sm-2'>
                      <TextField
                        id='invoice_number'
                        label='Invoice Number'
                        tabIndex={0}
                        fullWidth
                        placeholder=''
                        disabled
                        value={invoiceDetailsByInvoiceNum?.invoiceNum}
                        onChange={() => {}}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          maxLength: 10,
                        }}
                      />
                    </div>
                    <div className='mui-custom-form input-md col-sm-2'>
                      <TextField
                        id='manufacturer'
                        label='Manufacturer'
                        fullWidth
                        tabIndex={0}
                        placeholder=''
                        disabled
                        value={invoiceDetailsByInvoiceNum?.mfgId}
                        onChange={() => {}}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          maxLength: 10,
                        }}
                      />
                    </div>
                    <div className='mui-custom-form input-md col-sm-2'>
                      {invoiceDetailsByInvoiceNum?.mfgName?.length > 10 ? (
                        <OverlayTrigger
                          placement='bottom'
                          overlay={
                            <Tooltip id='com-tooltip'>
                              {invoiceDetailsByInvoiceNum?.mfgName}
                            </Tooltip>
                          }
                        >
                          <TextField
                            id='header_name'
                            label='Name'
                            fullWidth
                            placeholder=''
                            tabIndex={0}
                            disabled
                            value={`${invoiceDetailsByInvoiceNum?.mfgName.substring(
                              0,
                              10
                            )} ...`}
                            onChange={() => {}}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              maxLength: 10,
                            }}
                          />
                        </OverlayTrigger>
                      ) : (
                        <TextField
                          id='header_name'
                          label='Name'
                          fullWidth
                          placeholder=''
                          tabIndex={0}
                          disabled
                          value={invoiceDetailsByInvoiceNum?.mfgName}
                          onChange={() => {}}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{
                            maxLength: 10,
                          }}
                        />
                      )}
                    </div>
                    <div
                      className='mui-custom-form with-select input-md mui-custom-form-with-margin2 col-sm-3'
                      style={{ maxWidth: '20%' }}
                    >
                      <div className='sub-radio text-black sub-label mt-4'>
                        <FormControlLabel
                          control={
                            <Checkbox
                              color='primary'
                              defaultChecked
                              checked={duplicateInvoice}
                              name='duplicateInvoice'
                              onChange={(e) => {
                                duplicateInvoiceUpdate(e);
                              }}
                            />
                          }
                          label='Duplicate Invoice'
                        />
                      </div>
                    </div>
                    <div className='mui-custom-form col-sm-2'>
                      <Button
                        id='name-filter-btn-id'
                        title='Print All'
                        data-testid='print-All-btn'
                        className='btn btn-success btn-search ml-1 mt-3 float-right'
                        onClick={() => {
                          onClickPrint();
                        }}
                      >
                        <SVGComponent iconName='Icon-print' /> {'  '} {'  '}{' '}
                        Print All
                      </Button>
                    </div>
                  </div>
                </form>
              </fieldset>
            </>
          )}
          <InvoiceTabs
            setLoading={setLoading}
            setFullScreenView={setFullScreenView}
            fullScreenView={fullScreenView}
            invoiceDetailsByInvoiceNum={invoiceDetailsByInvoiceNum}
            duplicateInvoice={duplicateInvoice}
            handleErrorMessages={handleErrorMessages}
          />
        </div>
      </div>
    </>
  );
}
export default withRouter(RequestInvoiceReportDetails);
